import React from "react"
import PropTypes from "prop-types"

import Modal from "shared/components/modal"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import Cookies from "js-cookie"

import SMSForm from "./sms_form"
import AppDownloadButton from "./app_download_button"

import "./index.scss"

export default class MobileAlert extends React.Component {
  constructor(props) {
    super(props)

    this.state = { showModal: false }
  }

  UNSAFE_componentWillMount() {
    const { user, applet } = this.props
    // Session cookies, will be removed when browser closed.
    const cookieKey = `mobile_alert_${user.login}_${applet.id}`
    const hasViewedMobileAlert = Cookies.get(cookieKey)

    if (
      !hasViewedMobileAlert &&
      applet.status === "enabled_for_user" &&
      applet.just_enabled &&
      applet.requires_mobile_app &&
      user.availableClients !== "[:mobile]"
    ) {
      this.setState({ showModal: true })

      Cookies.set(cookieKey, true)
    }
  }

  closeMobileAlertModal = () => {
    logIFTTTNextAction("click", {
      object_type: "mobile_alert",
      object_id: "close",
      location_type: "connection",
      connection_id: this.props.applet.id,
    })

    this.setState({ showModal: false })
  }

  render() {
    return (
      <div className="mobile-alert-modal">
        <Modal
          show={this.state.showModal}
          closeListener={this.closeMobileAlertModal}
        >
          <div className="mobile-alert-container">
            <p>
              This Applet needs
              <br /> the IFTTT app
            </p>
            {this.props.userDevice === "desktop" ? (
              <SMSForm
                applet={this.props.applet}
                closeModal={this.closeMobileAlertModal}
                appStorePath={this.props.appStorePath}
                googlePlayStorePath={this.props.googlePlayStorePath}
              />
            ) : (
              <AppDownloadButton
                applet={this.props.applet}
                userDevice={this.props.userDevice}
                appStorePath={this.props.appStorePath}
                googlePlayStorePath={this.props.googlePlayStorePath}
              />
            )}
          </div>
        </Modal>
      </div>
    )
  }
}

MobileAlert.propTypes = {
  userDevice: PropTypes.string,
  user: PropTypes.shape({
    availableClients: PropTypes.string,
    login: PropTypes.string,
  }),
  appStorePath: PropTypes.string.isRequired,
  googlePlayStorePath: PropTypes.string.isRequired,
  applet: PropTypes.shape({
    id: PropTypes.string,
    requires_mobile_app: PropTypes.boolean,
    status: PropTypes.boolean,
    just_enabled: PropTypes.boolean,
  }).isRequired,
}

MobileAlert.defaultProps = {
  userDevice: "desktop",
}
